import React from "react";

import NLISLogo from "components/NLISLogoStatus";

export const ENVDEmailRecipientIcon = () => (
  <span title="eNVD Recipient">
    <NLISLogo />
  </span>
);
